import React, { useState, useEffect } from 'react'
import { Row, Col } from 'react-bootstrap'
import { addToLocal } from '../../../services/localStorageService'
import { getFilteredCountries } from '../../../services/countryService'
import constants from '../../../config/constants'
import CountryRow from './countryRow'
import { StoreKey } from '../../../config/enums'
import { useHistory } from 'react-router'
import Layout from '../../common/layout/layout'
import { Country } from '../../../models/Country'

function HomeCountry() {
  const history = useHistory()
  const [countryList, setCountryList] = useState<Country[]>([])

  useEffect(() => {
    getFilteredCountries(constants.homeCountries).then(countries => {
      setCountryList(countries)
    })
  }, [])

  return (
    <Layout>
      <Row>
        <Col xl={8} className="mx-auto">
          <Row>
            <Col xs={12}>
              <h1 className="pageTitle">Home Country</h1>
              <p className="pageSubtitle">Which country are you from?</p>
            </Col>
          </Row>
          <Row className="mt-3">
            {countryList.map(country => {
              return (
                <CountryRow
                  key={country.id}
                  country={country}
                  onSelectRow={countryId => {
                    addToLocal(StoreKey.homeCountry, countryId)
                    history.push('/onboarding/workcountry')
                  }}
                />
              )
            })}
          </Row>
        </Col>
      </Row>
    </Layout>
  )
}

export default HomeCountry
